import { useState, useEffect, useRef } from "react";
import { faq } from "@/mocks/faq";

const TELEGRAM_URL = "https://t.me/Vertttess";

export default function FaqSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-in-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="faq"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-background-50"
    >
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="reveal opacity-0 inline-block px-4 py-1.5 text-xs font-medium tracking-widest uppercase bg-primary-100 text-primary-700 rounded-full mb-4">
            Ответы на вопросы
          </span>
          <h2 className="reveal opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-900 mb-4">
            Вопросы и ответы
          </h2>
          <p className="reveal opacity-0 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            Собрали самые частые вопросы от владельцев гостиничного бизнеса
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faq.map((item) => (
            <div
              key={item.id}
              className="reveal opacity-0 bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300/60 transition-all duration-300"
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-start justify-between gap-4 p-5 md:p-6 text-left"
              >
                <span className="font-heading text-lg md:text-xl text-foreground-900 leading-snug">
                  {item.question}
                </span>
                <span
                  className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-transform duration-300 ${
                    openId === item.id ? "rotate-180" : ""
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-lg" />
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="reveal opacity-0 mt-12 md:mt-16 text-center">
          <p className="text-base md:text-lg text-foreground-600 mb-5">
            Остались вопросы? Напишите нам — ответим в течение часа
          </p>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 text-base font-medium bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
          >
            <i className="ri-telegram-line text-xl" />
            Связаться в Telegram
          </a>
        </div>
      </div>
    </section>
  );
}